import { useMutation } from '@hooks/reactQuery';

import { deleteNoFileRules } from '@api/alarmManagement';

import { IId } from '@interfaces/common/common';

import { ALARM_DELETE_NO_FILE_RULE_ORAN } from '@constants/queryKeys';

interface IUseMutateAlarmsDeleteNoFileRulesReturn {
	deleteAlarmNoFileRules: (data: IId[]) => void;
	isLoadingDeleteAlarmNoFileRules: boolean;
}

export const useMutateAlarmsDeleteNoFileRules = (): IUseMutateAlarmsDeleteNoFileRulesReturn => {
	const {
		mutateAsync,
		isLoading,
	} = useMutation<IId[]>({
		mutationKey: [ALARM_DELETE_NO_FILE_RULE_ORAN],
		mutationFn: deleteNoFileRules,
	});

	return {
		deleteAlarmNoFileRules: mutateAsync,
		isLoadingDeleteAlarmNoFileRules: isLoading,
	};
};
